export default "__VITE_ASSET__BrcZl5mJ__"